export class ShareLink {
    resourceid: number;
    resourcetype: string;
    shareoption: number;
    permissions: number;
    expiry: string;
    pwrd: string;
    approvenewversions: number;
    applywatermark: number;
    notification: number;
    ismysite:boolean;  
  }


  
  